<nz-sider
  class="menu-sidebar"
  [nzWidth]="110"
  [nzCollapsedWidth]="80"
  nzBreakpoint="md"
  [nzTrigger]="null"
>
  <div class="sidebar-logo">
    <a routerLink="/dashboard">
      <img [src]="Image.logo" alt="logo" />
    </a>
  </div>

  <div class="menu-container">
    <ul
      nz-menu
      [nzMode]="'vertical'"
      [nzInlineCollapsed]="isCollapsed"
      [nzTheme]="'light'"
    >
      @for (item of menus(); track item.label) {
        @if (!item?.hidden()) {
          @if (hasChildren(item)) {
            <li
              class="relative justify-center"
              nz-menu-item
              nzMatchRouter
              [class.parent-active]="isParentActive(item)"
              (mouseenter)="showSubmenu(item)"
              (mouseleave)="hideSubmenu()"
            >
              <div class="flex flex-col items-center">
                @if (item.icon) {
                  <ng-container *ngComponentOutlet="item.icon"></ng-container>
                }
                <span class="!text-[16px]">{{ item.label }}</span>
              </div>
              <div class="absolute top-[42px] right-[7px]">
                <app-arrow-right-icon />
              </div>
            </li>
          } @else {
            <li
              nz-menu-item
              nzMatchRouter
              class="justify-center"
              (mouseenter)="hideSubmenu()"
            >
              <a
                [routerLink]="item.routerLink"
                class="flex flex-col items-center"
              >
                @if (item.icon) {
                  <ng-container *ngComponentOutlet="item.icon"></ng-container>
                }
                <span class="!text-[16px]">{{ item.label }}</span>
              </a>
            </li>
          }
        }
      }
    </ul>
  </div>

  <!-- Custom Submenu Overlay -->
  @if (activeSubmenu() && activeSubmenu()?.child) {
    <div
      class="submenu-overlay"
      (mouseenter)="cancelHideSubmenu()"
      (mouseleave)="hideSubmenu()"
    >
      <ul nz-menu [nzMode]="'vertical'" [nzTheme]="'light'">
        @for (child of activeSubmenu()!.child; track child.label) {
          @if (!child?.hidden()) {
            <li nz-menu-item nzMatchRouter>
              <a [routerLink]="child.routerLink">
                <span>{{ child.label }}</span>
              </a>
            </li>
          }
        }
      </ul>
    </div>
  }
</nz-sider>
